<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="projectName" placeholder="请输入项目模板名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getProjectList()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo()">新增</el-button>
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list">
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="projectName" label="项目模板名称"></el-table-column>
                <el-table-column prop="docTitle" label="申请导入模板"></el-table-column>
                <!-- <el-table-column prop="isStrat" label="是否开始">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isStrat==1">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="isShow" label="是否展示">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isShow==1">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="startTime" label="开始时间"></el-table-column>
                <el-table-column prop="endTime" label="结束时间"></el-table-column> -->
                <el-table-column prop="isShow" label="申请是否上传附件">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isUploadFile==1">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNum" label="排序"></el-table-column>
                <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
                <el-table-column label="操作" width="400px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="goCustomForm(scope.row.id)">表单配置</el-button>
                        <!-- <el-button size="mini" type="primary" @click="goProjectApplyManager(scope.row.id)">申请列表</el-button> -->
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    v-show="totalCount > 0"
                    style="text-align: center"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :title="titleFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="800px">
            <el-form :model="form" class="demo-form-inline" label-width="150px">
                <el-form-item label="项目模板名称">
                    <el-input v-model="form.projectName"></el-input>
                </el-form-item>
                <el-form-item label="申请导入模板">
                    <applyFileUpload
                        :url="urlAliyunOSS"
                        :files="files"
                        :fileLists="files"
                        :IsMultiple="false"
                        @done="onAllFilesUploadb"
                        class="apply-file-upload"
                    ></applyFileUpload>
                </el-form-item>
                <!-- <el-form-item label="是否开始">
                    <el-radio-group v-model="form.isStrat">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <!-- <el-form-item label="开始时间">
                    <el-date-picker
                        v-model="form.startTime"
                        type="datetime"
                        placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                 <el-form-item label="结束时间">
                    <el-date-picker
                        v-model="form.endTime"
                        type="datetime"
                        placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否展示">
                    <el-radio-group v-model="form.isShow">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="申请是否上传附件">
                    <el-radio-group v-model="form.isUploadFile">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.orderNum" :min="0" ></el-input-number>
                </el-form-item>
                <el-form-item label="注：">
                    <div style="color:red;">
                        <p>1、上传申请导入模板后则开启模板导入功能,反之不开启</p>
                        <p>2、申请导入模板需要跟表单配置字段名称、顺序、数目保持一致</p>
                        <p>3、若已经产生申请数据,请勿修改表单结构，否则会对之前申报数据造成影响</p>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import applyFileUpload from "components/uploads/uploadEnclosure.vue";
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            projectName: "",
            titleFormVisible:"",
            dialogFormVisible:false,
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
            list: [],
            files:[],
            form: {
                id: "",
                projectName: "",
                filebIds: [],
                isStrat: 0,
                isShow: 0,
                orderNum: 0,
                startTime:"",
                endTime:"",
                isUploadFile:0
            }
        };
    },
    components: {
        applyFileUpload
    },
    created() {
        this.getProjectList();
    },
    watch: {
       
    },
    methods: {
        onAllFilesUploadb(files) {
            this.form.filebIds = [];
            this.form.filebIds = files;
        },
        addInfo() {
            this.form.id = "";
            this.form.projectName = "";
            this.form.filebIds = [];
            this.form.isStrat = 0;
            this.form.isShow = 0;
            this.form.orderNum = 0;
            this.form.startTime = "";
            this.form.endTime = "";
            this.form.isUploadFile = 0;
            this.titleFormVisible = "新增";
            this.dialogFormVisible = true;
        },
        //添加、编辑
        editInfo() {
            var that = this;
            var docId = "";
            if(this.form.filebIds.length > 0){
                docId = this.form.filebIds[0];
            }

            this.$http
                .post("/api/XOrg/ProjectManager/addOrEditProject", {
                    id: this.form.id,
                    projectName: this.form.projectName,
                    docId: docId,
                    isStrat: this.form.isStrat,
                    isShow: this.form.isShow,
                    orderNum: this.form.orderNum,
                    startTime: this.form.startTime,
                    endTime: this.form.endTime,
                    isModel:1,
                    isUploadFile:this.form.isUploadFile,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getProjectList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.form.id = "";
            this.form.projectName = "";
            this.form.filebIds = [];
            this.form.isStrat = 0;
            this.form.isShow = 0;
            this.form.orderNum = 0;
            this.form.startTime = "";
            this.form.endTime = "";
            this.form.isUploadFile = 0;
            this.dialogFormVisible = false;
        },
        //弹出框赋值
        handleEdit(row) {
            this.form.id = row.id;
            this.form.projectName = row.projectName;
            this.form.filebIds = [];
            if(row.docId){
                this.form.filebIds.push(row.docId);
            }
            this.files = [];
            if(row.docId){
                this.files.push({
                    id:row.docId,
                    docPrviewUrl:row.docUrl,
                    name:row.docTitle,
                    url:row.docUrl,
                    status:2
                });
            }
            this.form.isStrat = row.isStrat;
            this.form.isShow = row.isShow;
            this.form.orderNum = row.orderNum;
            this.form.startTime = row.startTime;
            this.form.endTime = row.endTime;
            this.form.isUploadFile = row.isUploadFile;
            this.titleFormVisible = "编辑";
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ProjectManager/deleteProject", {
                        ids: id,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getProjectList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getProjectList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ProjectManager/getProjectList", {
                    projectName: this.projectName,
                    isModel:1,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getProjectList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getProjectList();
        },
        goCustomForm(id){
            this.$router.push({
                name: "customForm",
                params: {
                    projectId: id,
                },
            });
        },
        goProjectApplyManager(id){
            this.$router.push({
                name: "projectApplyManager",
                params: {
                    projectId: id,
                },
            });
        }
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
